export default "__VITE_ASSET__CtHo5lfl__"